// Paso 1 "Mis datos" del formulario de inscripción rediseñado (v2).
// Misma lógica que InscripcionAgregarMisDatos: mismas props (props_c), misma validación de
// identificación (validarIdentificacion.js) y los mismos inputs de archivo ocultos con sus ids,
// porque validarDatos (InscripcionAgregar.js) los lee con document.getElementById.
import React, { useState, useRef } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import PersonIcon from "@material-ui/icons/Person";
import PhoneIcon from "@material-ui/icons/Phone";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SchoolIcon from "@material-ui/icons/School";
import GroupIcon from "@material-ui/icons/Group";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import InputAdornment from "@material-ui/core/InputAdornment";
import EventIcon from "@material-ui/icons/Event";
import { es } from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";
import BuscarSelect from "../../general/BuscarSelect";
import AppBarModal from "../../general/AppBarModal";
import { BtnForm } from "../../general/BotonesAccion";
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from "../../../global/imagenes/emma_w.png";
import { validarIdentificacion, formatoFecha } from "../validarIdentificacion";
import { useEstilosInscripcion } from "./estilosInscripcion";
import { Seccion, Nota, columnas, CampoArchivo, TAMANO_MAXIMO_MB } from "./componentesInscripcion";

function MensajeValidacionId({ modal, mostrarmodal, mensaje, cargando }) {
  return (
    <Dialog open={modal} maxWidth="sm" fullWidth={true} onClose={() => mostrarmodal(false)}>
      <AppBarModal titulo="¡ Mensaje !" mostrarModal={mostrarmodal} titulo_accion="" />
      <DialogContent className="scroll">
        {cargando ? (
          <TareasTerminadas mensaje="Espere un momento. Estamos validando su numero de identificacion" marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true} />
        ) : (
          <Typography variant="body1" color="textSecondary" component="p" align="justify">{mensaje}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <BtnForm texto="Cerrar" callback={() => mostrarmodal(false)} />
      </DialogActions>
    </Dialog>
  );
}

// Fecha con calendario desplegable bajo el campo (no modal): al hacer clic en el campo se abre
// en el año, luego mes y día, y se cierra solo al elegir el día.
function CampoFecha({ label, value, onChange, onClose, error = false }) {
  return (
    <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
      <DatePicker
        variant="inline"
        autoOk
        required
        fullWidth
        error={error}
        label={label}
        format="yyyy/MM/dd"
        value={value}
        onChange={onChange}
        onClose={onClose}
        openTo="year"
        views={["year", "month", "date"]}
        maxDate={new Date()}
        maxDateMessage="La fecha debe ser menor que la fecha actual."
        invalidDateMessage="Formato Invalido"
        PopoverProps={{ anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" } }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <EventIcon style={{ color: "#757575", cursor: "pointer" }} />
            </InputAdornment>
          ),
        }}
      />
    </MuiPickersUtilsProvider>
  );
}

export default function PasoMisDatos({ props_c, setBotonSiguiente }) {
  const classes = useEstilosInscripcion();
  const [resultado, setResultado] = useState({ mensaje: "", cargando: true });

  let {
    tipos_identificacion, tipo_identificacion, setTipo_identificacion, identificacion, onChange,
    primer_nombre, segundo_nombre, primer_apellido, segundo_apellido, correo, telefono1, celular1,
    adj_identificacion, adj_diploma, adj_saber, adj_identificacion_final, adj_diploma_final, adj_saber_final,
    adj_certificado_final, setArchivo, grupos, grupo, setGrupo, discapacidades, discapacidad,
    setDiscapacidad, adj_certificado, modalMensajeValidacionId,
    mostrarModalMensajeValidacionId, validacion_doc, codigo_pruebas, setCodigo_pruebas, puntaje_pruebas,
    tipos_inscripcion_preg, tipo_inscripcion_preg, setTipoInscripcionPreg, habilitar_form,
    nombre_acudiente, celular_acudiente, correo_acudiente,
    generos, genero, setGenero, fechaNacimiento, setFechaNacimiento,
    fechaExpedicion, setFechaExpedicion, prefijo_codigo, setPrefijoCodigo, campo_error,
  } = props_c;

  // Se valida con número + fecha de expedición: al salir del número (si ya hay fecha) o al elegir la fecha
  // El calendario desplegable emite cambios (e incluso onAccept) en cada paso: año, mes y día.
  // Se guarda la última fecha elegida y se valida una sola vez al cerrarse el calendario,
  // y solo si cambió el número o la fecha desde la última validación.
  const fechaElegida = useRef(fechaExpedicion);
  const ultimaValidacion = useRef(null);
  const cambiarFechaExpedicion = (fecha) => {
    fechaElegida.current = fecha;
    setFechaExpedicion(fecha);
  };
  const cerrarCalendarioExpedicion = () => {
    const fecha = fechaElegida.current;
    const clave = `${identificacion}|${formatoFecha(fecha)}`;
    if (!fecha || !identificacion || clave === ultimaValidacion.current) return;
    ultimaValidacion.current = clave;
    validarIdentificacion(identificacion, fecha, props_c, setBotonSiguiente, setResultado);
  };
  // Al salir del número (si ya hay fecha); se registra para no repetir la misma validación al cerrar el calendario
  const validar_id = ({ target }) => {
    if (!target.value || !fechaElegida.current) return;
    ultimaValidacion.current = `${target.value}|${formatoFecha(fechaElegida.current)}`;
    validarIdentificacion(target.value, fechaElegida.current, props_c, setBotonSiguiente, setResultado);
  };
  const conCertificado = grupo !== "" && grupo.codigo !== "GRU_NIN" && grupo.codigo !== "GRU_LGB";
  const totalGrupo = grupo.codigo === "GRU_DIS" ? 2 : 1;
  const deshabilitado = !habilitar_form;
  // Campo marcado en rojo tras "Continuar" (campo_error lo define validarDatos en InscripcionAgregar)
  const err = (campo) => campo_error === campo;
  const marca = (campo) => (err(campo) ? { "data-error": "true" } : {});
  const claseSelect = (campo) => `${classes.campoSelect} ${err(campo) ? classes.campoSelectError : ""}`;

  return (
    <React.Fragment>
      <MensajeValidacionId modal={modalMensajeValidacionId} mostrarmodal={mostrarModalMensajeValidacionId} mensaje={resultado.mensaje} cargando={resultado.cargando} />

      <div style={{ display: "none" }}>
        <BuscarSelect datos={tipos_inscripcion_preg} cambiarEstado={(value) => setTipoInscripcionPreg(value)} valor={tipo_inscripcion_preg} id="select-motivo-solicitud" nombre="¿Cuál es el motivo de tu solicitud?" placeholder="Seleccione el motivo" />
      </div>

      <p className={classes.tituloPaso}>Cuéntanos quién eres</p>
      <p className={classes.descripcionPaso}>Los campos con * son obligatorios.</p>

      <Seccion icono={AssignmentIndIcon} titulo="Identificación">
        <Grid item {...marca("tipo_identificacion")} {...columnas(0, 3)}>
          <div className={claseSelect("tipo_identificacion")}><BuscarSelect datos={tipos_identificacion} cambiarEstado={(value) => setTipo_identificacion(value)} valor={tipo_identificacion} id="select-tipo-identificacion" nombre="Tipo de identificación" placeholder="Seleccione tipo" habilitado={habilitar_form} /></div>
        </Grid>
        <Grid item {...marca("identificacion")} {...columnas(1, 3)}>
          <TextField error={err("identificacion")} value={identificacion} required type="number" id="identificacion" name="identificacion" label="Número de identificación" fullWidth autoComplete="off" onChange={onChange} onBlur={validar_id} disabled={deshabilitado} />
        </Grid>
        <Grid item {...marca("fechaExpedicion")} {...columnas(2, 3)}>
          <CampoFecha error={err("fechaExpedicion")} label="Fecha de expedición" value={fechaExpedicion} onChange={cambiarFechaExpedicion} onClose={cerrarCalendarioExpedicion} />
        </Grid>
      </Seccion>

      <Seccion icono={PersonIcon} titulo="Datos personales">
        <Grid item {...marca("primer_nombre")} {...columnas(0, 6)}>
          <TextField error={err("primer_nombre")} value={primer_nombre} required id="primer_nombre" name="primer_nombre" label="Primer nombre" fullWidth autoComplete="given-name" onChange={onChange} disabled={deshabilitado} />
        </Grid>
        <Grid item {...columnas(1, 6)}>
          <TextField value={segundo_nombre} id="segundo_nombre" name="segundo_nombre" label="Segundo nombre" fullWidth onChange={onChange} disabled={deshabilitado} />
        </Grid>
        <Grid item {...marca("primer_apellido")} {...columnas(2, 6)}>
          <TextField error={err("primer_apellido")} value={primer_apellido} required id="primer_apellido" name="primer_apellido" label="Primer apellido" fullWidth autoComplete="family-name" onChange={onChange} disabled={deshabilitado} />
        </Grid>
        <Grid item {...columnas(3, 6)}>
          <TextField value={segundo_apellido} id="segundo_apellido" name="segundo_apellido" label="Segundo apellido" fullWidth onChange={onChange} disabled={deshabilitado} />
        </Grid>
        <Grid item {...marca("genero")} {...columnas(4, 6)}>
          <div className={claseSelect("genero")}><BuscarSelect datos={generos} cambiarEstado={(value) => setGenero(value)} valor={genero} id="select-genero" nombre="Género" placeholder="Seleccione género" habilitado={habilitar_form} /></div>
        </Grid>
        <Grid item {...marca("fechaNacimiento")} {...columnas(5, 6)}>
          <CampoFecha error={err("fechaNacimiento")} label="Fecha de nacimiento" value={fechaNacimiento} onChange={setFechaNacimiento} />
        </Grid>
      </Seccion>

      <Seccion icono={PhoneIcon} titulo="¿Cómo te contactamos?">
        <Grid item {...marca("celular1")} {...columnas(0, 3)}>
          <TextField error={err("celular1")} value={celular1} required type="tel" id="celular1" name="celular1" label="Celular" fullWidth autoComplete="tel" onChange={(e) => onChange({ target: { name: "celular1", value: e.target.value.replace(/\D/g, "") } })} inputProps={{ maxLength: 10, inputMode: "numeric" }} disabled={deshabilitado} />
        </Grid>
        <Grid item {...marca("telefono1")} {...columnas(1, 3)}>
          <TextField error={err("telefono1")} value={telefono1} required type="tel" id="telefono1" name="telefono1" label="Teléfono fijo" fullWidth onChange={(e) => onChange({ target: { name: "telefono1", value: e.target.value.replace(/\D/g, "") } })} inputProps={{ maxLength: 10, inputMode: "numeric" }} disabled={deshabilitado} />
        </Grid>
        <Grid item {...marca("correo")} {...columnas(2, 3)}>
          <TextField error={err("correo")} value={correo} required type="email" id="correo" name="correo" label="Correo personal" fullWidth autoComplete="email" onChange={onChange} disabled={deshabilitado} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Nota>Verifica bien tus datos de contacto, en especial tu correo: por ahí te llegará toda la información de tu proceso.</Nota>
        </Grid>
      </Seccion>

      <Seccion icono={SupervisorAccountIcon} titulo="Acudiente">
        <Grid item {...marca("nombre_acudiente")} {...columnas(0, 3)}>
          <TextField error={err("nombre_acudiente")} value={nombre_acudiente} required id="nombre_acudiente" name="nombre_acudiente" label="Nombre completo del acudiente" fullWidth onChange={onChange} disabled={deshabilitado} />
        </Grid>
        <Grid item {...marca("celular_acudiente")} {...columnas(1, 3)}>
          <TextField error={err("celular_acudiente")} value={celular_acudiente} required type="tel" id="celular_acudiente" name="celular_acudiente" label="Celular del acudiente" fullWidth onChange={(e) => onChange({ target: { name: "celular_acudiente", value: e.target.value.replace(/\D/g, "") } })} inputProps={{ maxLength: 10, inputMode: "numeric" }} disabled={deshabilitado} />
        </Grid>
        <Grid item {...marca("correo_acudiente")} {...columnas(2, 3)}>
          <TextField error={err("correo_acudiente")} value={correo_acudiente} required type="email" id="correo_acudiente" name="correo_acudiente" label="Correo del acudiente" fullWidth onChange={onChange} disabled={deshabilitado} />
        </Grid>
      </Seccion>

      <Seccion icono={SchoolIcon} titulo="Pruebas Saber 11">
        {/* Solo prefijo, código y puntaje: el tipo y número de identificación de la prueba se envían
            automáticamente con el documento del aspirante (ver guardarInscripcion) */}
        <Grid item {...marca("prefijo_codigo")} xs={4} sm={3} lg={2}>
          <FormControl className="form-control" error={err("prefijo_codigo")}>
            <InputLabel required>Prefijo</InputLabel>
            <Select id="prefijo_codigo" value={prefijo_codigo} onChange={(e) => setPrefijoCodigo(e.target.value)} name="prefijo_codigo">
              <MenuItem key="AC" value="AC">AC</MenuItem>
              <MenuItem key="VG" value="VG">VG</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item {...marca("codigo_pruebas")} xs={8} sm={5} lg={6}>
          <TextField
            error={err("codigo_pruebas")}
            value={codigo_pruebas}
            required
            id="codigo_pruebas"
            name="codigo_pruebas"
            type="text"
            label="Código de registro"
            fullWidth
            onChange={(e) => setCodigo_pruebas(e.target.value.replace(/[^0-9]/g, ""))}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item {...marca("puntaje_pruebas")} xs={12} sm={4} lg={4}>
          <TextField
            error={err("puntaje_pruebas")}
            value={puntaje_pruebas}
            required
            type="number"
            id="puntaje_pruebas"
            name="puntaje_pruebas"
            label="Puntaje global"
            fullWidth
            onChange={onChange}
            inputProps={{ min: "1", max: "500" }}
            disabled={deshabilitado}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Nota>Verifica tu código de registro: es muy importante durante tu proceso.</Nota>
        </Grid>
      </Seccion>

      <Seccion icono={GroupIcon} titulo="Grupo o comunidad">
        <Grid item {...marca("grupo")} {...columnas(0, totalGrupo)}>
          <div className={claseSelect("grupo")}><BuscarSelect datos={grupos} cambiarEstado={(value) => setGrupo(value)} valor={grupo} id="select-tipo-grupo" nombre="¿Perteneces a alguno de estos grupos?" placeholder="Seleccione grupo" habilitado={habilitar_form} /></div>
        </Grid>
        {grupo.codigo === "GRU_DIS" && (
          <Grid item {...marca("discapacidad")} {...columnas(1, totalGrupo)}>
            <div className={claseSelect("discapacidad")}><BuscarSelect datos={discapacidades} cambiarEstado={(value) => setDiscapacidad(value)} valor={discapacidad} id="select-tipo-discapacidad" nombre="Tipo de discapacidad" placeholder="Seleccione discapacidad" habilitado={habilitar_form} /></div>
          </Grid>
        )}
      </Seccion>

      <Seccion icono={AttachFileIcon} titulo="Documentos">
        <Grid item xs={12}>
          <p className={classes.archivoAyuda}>PDF, JPG o PNG · máximo {TAMANO_MAXIMO_MB} MB por archivo.</p>
        </Grid>
        <Grid item xs={12} {...marca("adj_identificacion")}>
          <CampoArchivo id="archivo-adj_identificacion" label="Identificación (ambas caras)" required={validacion_doc[0].valora === "1"} nombre={adj_identificacion} archivo={adj_identificacion_final} onCambiar={(f) => setArchivo("adj_identificacion", f)} error={err("adj_identificacion")} />
        </Grid>
        <Grid item xs={12} {...marca("adj_diploma")}>
          <CampoArchivo id="archivo-adj_diploma" label="Diploma o acta de grado" required={validacion_doc[2].valora === "1"} nombre={adj_diploma} archivo={adj_diploma_final} onCambiar={(f) => setArchivo("adj_diploma", f)} error={err("adj_diploma")} />
        </Grid>
        <Grid item xs={12} {...marca("adj_saber")}>
          <CampoArchivo id="archivo-adj_saber" label="Resultado de las pruebas Saber 11" required={validacion_doc[1].valora === "1"} nombre={adj_saber} archivo={adj_saber_final} onCambiar={(f) => setArchivo("adj_saber", f)} error={err("adj_saber")} />
        </Grid>
        {conCertificado && (
          <Grid item xs={12} {...marca("adj_certificado")}>
            <CampoArchivo id="archivo-adj_certificado" label="Certificado médico de discapacidad o comunidad especial" required={validacion_doc[3].valora === "1"} nombre={adj_certificado} archivo={adj_certificado_final} onCambiar={(f) => setArchivo("adj_certificado", f)} error={err("adj_certificado")} />
          </Grid>
        )}
      </Seccion>
    </React.Fragment>
  );
}
